import { __decorate } from "tslib";
// declare function require(img: string): string;
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { gaodeMapJS } from "@/common/add-js";
import { State } from "vuex-class";
import homeSelect from "../home-select/home-select.vue";
import { getBigScreenStationMap, getBigchargeCo2, getMapStaInfo, } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
import { MapType } from "../../home-screen.enum";
const staHomeIcon = require("../../img/map/sta-home.png"); // eslint-disable-line
const staAddrIcon = require("../../img/map/sta-addr.png"); // eslint-disable-line
const staTelIcon = require("../../img/map/sta-tel.png"); // eslint-disable-line
const defaultPicture = require("../../img/map/default-picture.png"); // eslint-disable-line
let PiHomeDataMap = class PiHomeDataMap extends Vue {
    constructor() {
        super(...arguments);
        this.MapType = MapType;
        this.loading = false;
        this.map = {};
        this.win = window;
        this.isInit = false;
        this.isMap = false;
        this.points = [];
        this.activeSelect = "2";
        this.selectObj = {
            "2": i18n.t("homeData.mapSelectText4"),
            "3": i18n.t("homeData.mapSelectText5"),
            "4": i18n.t("homeData.mapSelectText2"),
            "5": i18n.t("homeData.mapSelectText3"),
            "6": i18n.t("homeData.mapSelectText6"),
            "7": i18n.t("homeData.mapSelectText7"),
            "8": i18n.t("homeData.mapSelectText8"),
        };
        this.selectStaPkId = ""; // 选中的站点
        this.markerList = []; // 站点标记
        this.dlMapData = []; // 充电电量
        this.moneyMapData = []; // 充电营收
        this.totalChargingSeconds = []; // 充电订单
        this.totalChargingTimes = []; // 充电时长
        this.activeNumber = []; // 充电用户数量
        this.usageRate = []; // 充电使用率
        this.useRatio = []; // 充电利用率
        this.mapActive = "1";
        this.mapColorActive = MapType.Type1.toString();
        this.heatmap = {};
        this.co2List = [];
        this.co2Obj = {
            "1": i18n.t("homeData.coal"),
            "2": i18n.t("homeData.oil"),
            "3": i18n.t("homeData.co2"),
            "4": i18n.t("homeData.so2"),
            "5": i18n.t("homeData.no2"),
        };
        this.oprInfo = {};
        this.MarkerClusterer = {};
        this.staPkId = "";
        this.isLoadingSuccess = false;
    }
    getVisible() {
        this.getBigchargeCo2();
        this.getCityMarker();
        this.mapColorClick(MapType.Type1.toString());
    }
    /**
     * 监听轮循的 type ，显示对应的数据
     */
    "Watch.showType"() {
        this.mapColorActive = this.showType;
        this.mapColorClick(this.mapColorActive);
    }
    refreshClick() {
        this.selectStaPkId = "";
        this.heatMapHide();
        this.mapColorActive = MapType.Type1.toString();
        this.getBigchargeCo2();
        this.getCityMarker();
    }
    async addMapJS() {
        await gaodeMapJS();
        this.mapShow();
    }
    mapShow() {
        if (!this.win.AMap) {
            setTimeout(() => {
                this.mapShow();
            }, 500);
            return;
        }
        if (!this.isMap) {
            let zoom = 8;
            let center = [this.$config.position.lng, this.$config.position.lat];
            if (this.sys.userType == "admin") {
                zoom = 5;
                center = [106.56283, 31.637154];
            }
            else if (this.oprInfo.lng) {
                center = [this.oprInfo.lng, this.oprInfo.lat];
            }
            this.map = new this.win.AMap.Map("map", {
                resizeEnable: true,
                center: center,
                zoom: zoom,
                // mapStyle: "amap://styles/58a7e6784f8bce9f32598338eee88bb1",
                mapStyle: "amap://styles/448d6e91038abc7093aeb78638ea78d5",
            });
            // 监听地图实例的 complete 事件
            this.map.on("complete", () => {
                this.isMap = true;
                console.log("地图加载完成");
            });
        }
        else {
            // 清除所有聚合点
            // this.MarkerClusterer.clearMarkers();
            this.clearMarker();
        }
        this.points = [];
        this.markerList.map((item, index) => {
            let json = {
                weight: 8,
                lnglat: [item.lng, item.lat],
                index: index,
                staPkId: item.staPkId,
            };
            this.points.push(json);
        });
        // const count: number = this.points.length;
        const _renderCluserMarker = (context) => {
            const div = document.createElement("div");
            div.innerHTML = context.count;
            let size = 60;
            if (context.count < 10) {
                div.className = "dian-bg small";
                size = 60;
            }
            else if (context.count < 100) {
                div.className = "dian-bg large";
                size = 72;
            }
            else if (context.count > 100) {
                div.className = "dian-bg greatly";
                size = 88;
            }
            // const size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
            context.marker.setOffset(new this.win.AMap.Pixel(-size / 2, -size / 2));
            context.marker.setContent(div);
        };
        const _renderMarker = (context) => {
            let index = context.data[0].index || "";
            let staPkId = context.data[0].staPkId || "";
            let active = this.selectStaPkId == staPkId ? " dian-active" : "";
            const content = '<div class="dian-bg dian-site dian-site-' +
                index +
                active +
                '" data-index="' +
                index +
                '" data-id="' +
                staPkId +
                '"></div>';
            const offset = new this.win.AMap.Pixel(-15, -15);
            context.marker.setContent(content);
            context.marker.setOffset(offset);
        };
        this.MarkerClusterer = new this.win.AMap.MarkerCluster(this.map, this.points, {
            gridSize: 60,
            renderClusterMarker: _renderCluserMarker,
            renderMarker: _renderMarker,
        });
        this.MarkerClusterer.on("click", (mark) => {
            const clusterData = mark.clusterData[0];
            if (mark.clusterData.length > 1) {
                const zoom = this.map.getZoom() + 2;
                this.map.setZoomAndCenter(zoom, [
                    clusterData.lnglat.lng,
                    clusterData.lnglat.lat,
                ]);
            }
            else {
                let index = this.markerList.findIndex((item) => {
                    return item.lat == mark.lnglat.lat && item.lng == mark.lnglat.lng;
                });
                console.log(mark);
                let divIndex = mark.clusterData[0].index;
                this.addClickHandler(this.markerList[index], divIndex);
            }
        });
    }
    clearMarker() {
        this.MarkerClusterer.setMap(null);
        this.map.clearMap();
    }
    // 地图切换
    mapColorClick(active) {
        this.mapColorActive = active;
        if (active == MapType.Type1.toString()) {
            this.mapTypeClick(active);
        }
        else {
            this.mapTypeClick(this.activeSelect);
        }
    }
    // 下拉选择
    selectItemClick(val) {
        this.activeSelect = val;
        this.mapTypeClick(val);
    }
    mapTypeClick(active) {
        this.mapActive = active;
        this.clearMarker();
        if (active == MapType.Type1.toString()) {
            this.heatMapHide();
            this.mapShow();
        }
        else {
            this.heatMapShow();
        }
    }
    heatMapShow() {
        let data = {};
        if (this.mapActive == "2") {
            data = this.dlMapData;
        }
        else if (this.mapActive == "3") {
            data = this.totalChargingSeconds;
        }
        else if (this.mapActive == "4") {
            data = this.totalChargingTimes;
        }
        else if (this.mapActive == "5") {
            data = this.activeNumber;
        }
        else if (this.mapActive == "6") {
            data = this.moneyMapData;
        }
        else if (this.mapActive == "7") {
            data = this.usageRate;
        }
        else if (this.mapActive == "8") {
            data = this.useRatio;
        }
        else {
            return;
        }
        // const data = this.mapActive == "2" ? this.dlMapData : this.moneyMapData;
        this.heatMapHide();
        this.map.plugin(["AMap.HeatMap"], () => {
            //初始化heatmap对象
            this.heatmap = new this.win.AMap.HeatMap(this.map, {
                radius: 25,
                opacity: [0, 0.8],
            });
            //设置数据集：该数据为北京部分“公园”数据
            this.heatmap.setDataSet({
                data: data,
                max: 100,
            });
            this.isLoadingSuccess = true;
        });
    }
    heatMapHide() {
        if (this.isLoadingSuccess) {
            this.isLoadingSuccess = false;
            this.heatmap.setMap(null);
        }
    }
    addClickHandler(item, divIndex) {
        // 点的事件
        this.selectStaPkId = item.staPkId;
        var divActice = document.getElementsByClassName("dian-active")[0];
        if (divActice) {
            divActice.className = divActice.className.replace("dian-active", "");
        }
        var div = document.getElementsByClassName("dian-site-" + divIndex)[0];
        if (div) {
            div.className = div.className + " dian-active";
        }
        this.openInfos(item);
    }
    async openInfos(item) {
        this.staPkId = item.staPkId;
        const ret = await getMapStaInfo({ staPkId: item.staPkId });
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data[0];
            let img = '<div class="no-picture">' +
                i18n.t("home.noPicture") +
                '</div><img src="' +
                defaultPicture +
                '" />';
            if (data.staPics && data.staPics.length > 0) {
                img =
                    '<img src="' +
                        this.$config.fileImg +
                        data.staPics[0].thumbnailFilePath +
                        '" />';
            }
            const info = `<div class="home-map-site-details">
          <div class="sta-point"></div>
          <div class="site-title">${data.staName}</div>
          <div class="site-details-content">
              <div class="site-img-box">${img}</div>
              <div class="site-info-flex">
                  <div class="site-pile-box">
                      <div class="site-pile-flex">
                          <div class="pile-info-value">${data.dcPileCount}${i18n.t("unitText.set")}</div>
                          <div class="pile-info-name">${i18n.t("home.mapDc")}</div>
                      </div>
                      <div class="site-pile-flex">
                          <div class="pile-info-value">${data.acPileCount}${i18n.t("unitText.set")}</div>
                          <div class="pile-info-name">${i18n.t("home.mapAc")}</div>
                      </div>
                      <div class="site-pile-flex">
                          <div class="pile-info-value">${data.totalPower || "-"}kWh</div>
                          <div class="pile-info-name">${i18n.t("home.totalPower")}</div>
                      </div>
                  </div>
                  <div class="info-box">
                      <div class="info-icon">
                          <img src="${staHomeIcon}" alt="">
                      </div>
                      <div class="info-text info-border">
                          ${data.oprName || "-"}
                      </div>
                  </div>
                  <div class="info-box">
                      <div class="info-icon">
                          <img src="${staAddrIcon}" alt="">
                      </div>
                      <div class="info-text info-border">
                          ${data.staAddress}
                      </div>
                  </div>
                  <div class="info-box">
                      <div class="info-icon">
                          <img src="${staTelIcon}" alt="">
                      </div>
                      <div class="info-text">
                          ${data.phoneNo}
                      </div>
                  </div>
              </div>
          </div>
      </div>`;
            const infoWindow = new this.win.AMap.InfoWindow({
                content: info,
            });
            infoWindow.open(this.map, [item.lng, item.lat]);
            this.siteClick();
            this.siteDetailClick();
        }
    }
    siteDetailClick() {
        const router = this["$router"];
        const staPkId = this.staPkId;
        const oprPkId = this.oprPkId || "";
        setTimeout(() => {
            const divObj = document.getElementById("site-detail");
            if (divObj != null) {
                divObj.onclick = function () {
                    router.push("/home/index/home-pile?staPkId=" + staPkId + "&oprPkId=" + oprPkId);
                };
            }
            else {
                this.siteDetailClick();
            }
        }, 500);
    }
    siteClick() {
        const router = this["$router"];
        setTimeout(() => {
            const divObj = document.getElementById("site-name");
            if (divObj != null) {
                divObj.onclick = function () {
                    router.push("/pile-manage/operation-data?operId=1");
                };
            }
            else {
                this.siteClick();
            }
        }, 500);
    }
    async getCityMarker() {
        const params = {
            oprPkId: this.oprPkId,
        };
        this.loading = true;
        const ret = await getBigScreenStationMap(params);
        this.loading = false;
        if (ret.status === this.$config.apiStatus) {
            const data = ret.data || [];
            this.$emit("getDataSuccess", data);
            const markerList = [];
            const dlMapData = [];
            const moneyMapData = [];
            const totalAmount = [];
            const totalChargingSeconds = []; // 充电订单
            const totalChargingTimes = []; // 充电时长
            const activeNumber = []; // 充电用户
            const usageRate = []; // 充电使用率
            const useRatio = []; // 充电利用率
            data.map((item) => {
                markerList.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    staPkId: item.staPkId,
                });
                dlMapData.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.totalPower || 0,
                });
                moneyMapData.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.totalAmount || 0,
                });
                totalChargingSeconds.push({
                    // 返台的数据英文名是反的 totalChargingTimes 是订单  totalChargingSeconds是时长，
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.totalChargingTimes || 0,
                });
                totalChargingTimes.push({
                    // 返台的数据英文名是反的 totalChargingTimes 是订单  totalChargingSeconds是时长，
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.totalChargingSeconds || 0,
                });
                activeNumber.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.activeNumber || 0,
                });
                usageRate.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.usageRate || 0,
                });
                useRatio.push({
                    lat: item.staLat,
                    lng: item.staLng,
                    count: item.useRatio || 0,
                });
                totalAmount.push(item.totalAmount);
            });
            this.markerList = markerList;
            this.dlMapData = dlMapData;
            this.moneyMapData = moneyMapData;
            this.totalChargingSeconds = totalChargingSeconds;
            this.totalChargingTimes = totalChargingTimes;
            this.activeNumber = activeNumber;
        }
        this.addMapJS();
    }
    async getBigchargeCo2() {
        const ret = await getBigchargeCo2({ oprPkId: this.oprPkId });
        if (ret.status === this.$config.apiStatus) {
            this.co2List = ret.data || [];
        }
        this.isInit = true;
    }
    getOprInfo() {
        this.oprInfo = this.sys.operInfo;
        this.getCityMarker();
    }
    activated() {
        console.log(this.map);
        if (!this.isMap) {
            console.log("地图加载不成功，再来一次");
            this.$nextTick(this.getOprInfo);
        }
    }
    mounted() {
        this.getBigchargeCo2();
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataMap.prototype, "showType", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeDataMap.prototype, "oprPkId", void 0);
__decorate([
    Watch("oprPkId")
], PiHomeDataMap.prototype, "getVisible", null);
__decorate([
    Watch("showType")
], PiHomeDataMap.prototype, "Watch.showType", null);
__decorate([
    State("sys")
], PiHomeDataMap.prototype, "sys", void 0);
PiHomeDataMap = __decorate([
    Component({
        components: {
            "pi-home-select": homeSelect,
        },
    })
], PiHomeDataMap);
export default PiHomeDataMap;
